import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Copy, Trash2, Edit3, Palette, ChevronRight, FolderMinus } from 'lucide-react';

const MindMapContextMenu = ({
  isOpen,
  position,
  selectedNode,
  onClose,
  onAddChild,
  onEdit,
  onDelete,
  onDuplicate,
  onCollapse,
}) => {
  if (!isOpen) return null;

  const menuItems = [
    { 
      icon: Plus, 
      label: 'Add Child', 
      shortcut: 'Tab',
      onClick: () => { onAddChild(); onClose(); },
      show: true,
    },
    { 
      icon: Edit3, 
      label: 'Edit', 
      shortcut: 'Enter',
      onClick: () => { onEdit(); onClose(); },
      show: !!selectedNode,
    },
    { 
      icon: FolderMinus, 
      label: selectedNode?.collapsed ? 'Expand' : 'Collapse', 
      shortcut: '',
      onClick: () => { onCollapse(); onClose(); },
      show: !!selectedNode,
    },
    { type: 'divider', show: !!selectedNode },
    { 
      icon: Copy, 
      label: 'Duplicate', 
      shortcut: 'Ctrl+D',
      onClick: () => { onDuplicate(); onClose(); },
      show: !!selectedNode,
    },
    { type: 'divider', show: !!selectedNode },
    { 
      icon: Trash2, 
      label: 'Delete', 
      shortcut: 'Del',
      onClick: () => { onDelete(); onClose(); },
      show: !!selectedNode,
      danger: true,
    },
  ];

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.1 }}
        className="fixed z-[100] min-w-[180px] bg-[#1a1d24] border border-white/10 rounded-lg shadow-2xl py-1 overflow-hidden"
        style={{ left: position.x, top: position.y }}
        onClick={(e) => e.stopPropagation()}
      >
        {menuItems.filter(item => item.show).map((item, index) => {
          if (item.type === 'divider') {
            return <div key={index} className="h-px bg-white/10 my-1" />;
          }
          
          const Icon = item.icon;
          return (
            <button
              key={index}
              onClick={item.onClick}
              className={`
                w-full flex items-center gap-3 px-3 py-2 text-sm transition-colors
                ${item.danger 
                  ? 'text-red-400 hover:bg-red-500/10' 
                  : 'text-zinc-300 hover:bg-white/5 hover:text-white'
                }
              `}
            >
              <Icon size={15} />
              <span className="flex-1 text-left">{item.label}</span>
              {item.shortcut && (
                <span className="text-xs text-zinc-500">{item.shortcut}</span>
              )}
            </button>
          );
        })}
      </motion.div>
    </AnimatePresence>
  );
};

export default MindMapContextMenu;
